/*
 * Formata o log gravado no formato "label 1: valor 1 | label n: valor n |"
 */
export function fn_formatarLog(log, campos, somenteValor = false) {
  if (log) {
    let camposLog = campos;

    if (campos && !Array.isArray(campos)) {
      //se não for passado como array, coloca no array
      camposLog = [campos];
    }

    camposLog = camposLog?.map((campo) => campo.toUpperCase());

    const logs = log.split("|");

    return logs.map((item, index) => {
      if (item.trim().length > 0) {
        const valores = item.split(":");
        const label = valores[0].trim();
        const valor = valores[1].trim();

        if (!camposLog || camposLog.includes(label.toUpperCase())) {
          return (
            <div key={index}>
              {!somenteValor && <span className="fw-bold me-2">{label}:</span>}
              {valor}
            </div>
          );
        }
      }
    });
  }
}
